import { render } from "./AttendanceRecordForm.vue?vue&type=template&id=b8aaa1b0"
import script from "./AttendanceRecordForm.vue?vue&type=script&lang=js"
export * from "./AttendanceRecordForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__